import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { MarketplacePartnerRegisterPageFormCategoriesSelection } from './MarketplacePartnerRegisterPageFormCategoriesSelection'

export const MarketplacePartnerRegisterPageFormCategories: FC = () => {
  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.categories.title" />
      </Heading>
      <div className="text-m">
        <FormattedMessage id="marketplacePartnerRegisterPage.categories.description" />
      </div>
      <MarketplacePartnerRegisterPageFormCategoriesSelection />
    </div>
  )
}
